// extracted by mini-css-extract-plugin
module.exports = {"LimitAndTestTag":"DiceLimits_LimitAndTestTag__2ie-U","DiceInput":"DiceLimits_DiceInput__aYr6Z","Die":"DiceLimits_Die__3cy3q"};